module.exports = __webpack_public_path__ + "static/media/Note-Click-Bloom-Textures-Click_Boom_00045.6fd669ee.png";